import { PixFlowSettings, PixStep } from './pixFlow.types';

export const DEFAULT_PIX_FLOW: PixFlowSettings = {
  show_billing_address_page: true,
};

export function normalizePixFlow(
  pixFlow?: PixFlowSettings,
  fallbackShowShippingAddressPage?: boolean
): PixFlowSettings {
  if (pixFlow) return pixFlow;

  if (fallbackShowShippingAddressPage) {
    return { show_shipping_address_page: true };
  }

  return DEFAULT_PIX_FLOW;
}

export function buildPixSteps(pixFlow?: PixFlowSettings): PixStep[] {
  const steps: PixStep[] = [];

  if (pixFlow?.show_shipping_address_page) {
    steps.push('shipping-address');
  } else if (pixFlow?.show_billing_address_page) {
    steps.push('billing-address');
  }

  steps.push('payment');

  return steps;
}

export function isReducedPixFlow(pixFlow?: PixFlowSettings): boolean {
  return buildPixSteps(pixFlow).length === 1;
}
